import YouTube from 'react-youtube';

interface VideoModalProps {
  videoId: string;
  isOpen: boolean;
  onClose: () => void;
}

const YOUTUBE_OPTIONS = {
  height: '100%',
  width: '100%',
  playerVars: {
    autoplay: 1,
    controls: 1,
    modestbranding: 1,
    rel: 0,
    showinfo: 0,
    mute: 0,
    start: 0,
    fs: 1,
    iv_load_policy: 3,
    disablekb: 0,
    playsinline: 1,
  },
};

export default function VideoOverlay({
  videoId,
  isOpen,
  onClose,
}: VideoModalProps) {
  if (!isOpen) return null;

  const handleBackdropClick = () => {
    onClose();
  };

  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div
      className='fixed left-0 top-0 z-[99999] h-screen w-screen bg-black/90'
      onClick={handleBackdropClick}
    >
      <div
        className='container-padding container relative flex h-full items-center justify-center'
        onClick={stopPropagation}
      >
        <button
          className='absolute right-5 top-20 z-[100] rounded-full bg-white/10 px-4 py-4 text-white/90 transition duration-200 hover:bg-white/20 md:right-0'
          onClick={handleBackdropClick}
        >
          <svg
            className='h-4 w-4 text-white'
            xmlns='http://www.w3.org/2000/svg'
            width='23'
            height='23'
            viewBox='0 0 23 23'
            fill='none'
          >
            <path
              d='M21.5362 1.30971C21.8319 1.60542 21.9981 2.00649 21.9981 2.42469C21.9981 2.84289 21.8319 3.24396 21.5362 3.53967L3.69651 21.3794C3.4008 21.6751 2.99973 21.8412 2.58153 21.8412C2.16333 21.8412 1.76226 21.6751 1.46654 21.3794C1.17083 21.0837 1.0047 20.6826 1.0047 20.2644C1.0047 19.8462 1.17083 19.4451 1.46654 19.1494L19.3063 1.30971C19.602 1.014 20.003 0.847866 20.4212 0.847866C20.8394 0.847866 21.2405 1.014 21.5362 1.30971Z'
              fill='currentColor'
            />
            <path
              d='M21.5367 21.3807C21.241 21.6764 20.8399 21.8425 20.4217 21.8425C20.0035 21.8425 19.6025 21.6764 19.3068 21.3807L1.46705 3.54099C1.17134 3.24528 1.00521 2.84421 1.00521 2.42601C1.00521 2.00781 1.17134 1.60674 1.46705 1.31103C1.76276 1.01532 2.16383 0.849186 2.58203 0.849186C3.00023 0.849186 3.4013 1.01532 3.69701 1.31103L21.5367 19.1507C21.8324 19.4465 21.9986 19.8475 21.9986 20.2657C21.9986 20.6839 21.8324 21.085 21.5367 21.3807Z'
              fill='currentColor'
            />
          </svg>
        </button>
        <YouTube
          videoId={videoId}
          opts={YOUTUBE_OPTIONS}
          className='aspect-video w-full max-w-4xl overflow-hidden rounded-md bg-black [aspect-ratio:_16_/_9]'
          iframeClassName='aspect-video h-full w-full [aspect-ratio:16_/_9]'
        />
      </div>
    </div>
  );
}
